const LOCALIZATIONS = {
  authors: {
    ru: "Авторы",
    en: "Authors",
    de: "Autoren",
  },
  weather: {
    humidity: {
      ru: "Влажность",
      en: "Humidity",
      de: "Feuchtigkeit",
    },
    windSpeed: {
      ru: "Ветер",
      en: "Wind",
      de: "Windstärke",
    },
    units: {
      ru: "м/с",
      en: "m/s",
      de: "m/s",
    },
  },
  currency: {
    en: "Currency",
    ru: "Валюта",
    de: "Währung",
  },
  header: {
    logo: {
      en: "Travels",
      ru: "Путешествия",
      de: "Reisen",
    },
    singIn: {
      en: "Sing in",
      ru: "Войти",
      de: "Einloggen",
    },
    singUp: {
      en: "Sing up",
      ru: "Регистрация",
      de: "Anmelden",
    },
    singOut: {
      en: "Sing out",
      ru: "Выйти",
      de: "Ausloggen",
    },
    search: {
      en: "Search",
      ru: "Найти",
      de: "Suche",
    },
    placeholder: {
      en: "Enter text",
      ru: "Введите текст",
      de: "Text eingeben",
    },
    topPlaces: {
      en: "Top 10 places",
      ru: "10 лучших мест",
      de: "Top 10 Plätze",
    },
  },
  main: {
    countryCard: {
      footer: {
        en: "Click to find out more",
        ru: "Нажмите, чтобы узнать больше",
        de: "Klicken Sie hier, um mehr zu erfahren",
      },
    },
  },
  registration: {
    singUp: {
      en: "Sing Up",
      ru: "Регистрация",
      de: "Anmelden",
    },
    email: {
      en: "Email address",
      ru: "Адрес электронной почты",
      de: "E-Mail-Addresse",
    },
    inputEmail: {
      en: "Enter email",
      ru: "Введите адрес электронной почты",
      de: "Email eingeben",
    },
    name: {
      en: "Name",
      ru: "Имя",
      de: "Name",
    },
    inputName: {
      en: "Enter name",
      ru: "Введите имя",
      de: "Name eingeben",
    },
    password: {
      en: "Password",
      ru: "Пароль",
      de: "Passwort",
    },
    inputPassword: {
      en: "Enter password",
      ru: "Введите пароль",
      de: "Passwort eingeben",
    },
    create: {
      en: "Create profile",
      ru: "Создать профиль",
      de: "Profil erstellen",
    },
    image: {
      en: "Max file size: 5mb, accepted: jpg | gif | png",
      ru: "Максимальный размер файла: 5 МБ, разрешено: jpg | gif | png",
      de: "Maximale Dateigröße: 5 MB, akzeptiert: jpg | gif | png",
    },
    choose: {
      en: "Choose images",
      ru: "Выбрать изображения",
      de: "Wählen Sie Bilder",
    },
  },
  login: {
    singIn: {
      en: "Sing In",
      ru: "Войти",
      de: "Einloggen",
    },
  },
  topRating: {
    header: {
      en: "Top 10 places",
      ru: "10 лучших мест",
      de: "Top 10 Plätze",
    },
    avarageRating: {
      en: "average rating",
      ru: "средний рейтинг",
      de: "durchschnittliche Bewertung",
    },
    basedOn: {
      en: "based on",
      ru: "на основе",
      de: "basierend auf",
    },
    reviews: {
      en: "reviews",
      ru: "отзыва(-ов)",
      de: "Bewertungen",
    },
  },
  photoGallery: {
    you: {
      en: "You",
      ru: "Вы",
      de: "Sie",
    },
    comment: {
      en: "Comment",
      ru: "Kомментарий",
      de: "Kommentar",
    },
    commentDescription: {
      en: "Leave short comment (60 characters)",
      ru: "Оставьте короткий комментарий (60 символов)",
      de: "Hinterlasse einen kurzen Kommentar (60 Zeichen)",
    },
    leaveRating: {
      en: "To leave rating please",
      ru: "Для того, чтобы оставить рейтинг пожалуйста",
      de: "Um eine Bewertung abzugeben, bitte",
    },
    publish: {
      en: "Publish",
      ru: "Опубликовывать",
      de: "Veröffentlichen",
    },
    login: {
      en: "Sign in",
      ru: "Авторизуйтесь",
      de: "Einloggen",
    },
  },
  template: {
    en: "",
    ru: "",
    de: "",
  },
};

export default LOCALIZATIONS;
